<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bzim4C/tc-custom/9781250313638.jpg?1731055901084" alt="This image is the cover for the book Elon Musk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elon Musk
      </h1>
      <p class="bookDescription body article font2">
        <b>This YA biography reveals how the visionary behind SpaceX and Tesla became “arguably the most important and successful entrepreneur in the world” (<i>The New York Times</i>).</b><br/><br/>Online banking, reusable rockets, electric sports cars, improved solar power, colonizing Mars—Elon Musk is full of unique, daring, and highly-publicized ideas that he believes will help save the world.<br/><br/>But behind his legendary drive and sensational headlines is the story of a bullied school boy who, through creativity and determination, decided to rewrite his narrative and find groundbreaking ways to make the world a better place—all with his signature sense of fun and style.<br/><br/>From hosting raves to pay for college to rewriting the rules on space travel, Elon Musk has always gone his own way, to either the dismay or admiration of the general public. And now, award-winning investigative journalist Anna Crowley Redding takes readers on a revealing trip through Elon’s life and accomplishments.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Crowley Redding
      </h2>
      
      <p class="authorDescription body article"><B>Anna Crowley Redding</B> is the author of <I>Google It </I>and <I>Elon Musk: A Mission to Save the World. </I>Her first career was as an Emmy-award winning investigative television reporter, anchor, and journalist. The recipient of multiple Edward R. Murrow awards and recognized by the Associated Press for her reporting, Redding now focuses her stealthy detective skills on digging up great stories for kids—which, as it turns out, is her true passion.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e7d36a3